<template>
  <div class="mobile_vote">
    <div class="mobile_vote_head">
      <div class="mobile_head_left">
        <a @click="goBack()">
          <i class="el-icon-arrow-left"></i>
        </a>
      </div>
      <span class="mobile_head_desc"> 请投票 </span>
      <div class="mobile_head_right">
        <a @click="refresh()">
          <i class="el-icon-refresh-right"></i>
        </a>
      </div>
    </div>
    <div class="mobile_vote_bar" ref="mobileVoteBar">
      <div class="mobile_bar_main">
        <div class="mobile_bar_title">
          {{ voteInfo.VoteName }}
        </div>
        <div class="mobile_bar_tips">
          <div v-for="item in voteStates" :key="item.key">
            {{ item.value }}
            <span v-if="item.isCheckMaxMin">({{ item.maxNum }})</span>
            :
            <span class="num">{{ item.selectNum }}</span>
          </div>
        </div>
        <div class="mobile_bar_highlight">{{ voteInfo.VoteMessageConfig }}</div>
      </div>
    </div>
    <div class="mobile_vote_main" :style="voteMainStyle">
      <div
        class="mobile_project_box"
        v-for="(project, index) in voteInfo.VoteProjectList"
        :key="project.VoteProjectID"
      >
        <div class="project_item">
          <div class="project_title">
            {{ index + 1 }}、{{ project.VoteProjectName }}
          </div>
        </div>
        <div class="project_item">
          <i class="el-icon-s-opportunity icon_left icon_primary"></i>
          <div class="content">
            {{ project.VoteProjectRemark }}
          </div>
          <a
            @click="
              project.IsShowAdditionalRemark = !project.IsShowAdditionalRemark
            "
          >
            <i
              class="el-icon-caret-bottom icon_right icon_primary"
              :style="
                project.IsShowAdditionalRemark
                  ? 'transform: rotate(-180deg);transition: all .5s'
                  : 'transform: rotate(0deg);transition: all .5s'
              "
            ></i>
          </a>
        </div>
        <div class="project_item" v-show="project.IsShowAdditionalRemark">
          <i
            class="el-icon-s-opportunity icon_left icon_warning"
            v-show="project.VoteProjectAdditionalRemark"
          ></i>
          <div
            class="content"
            v-html="project.VoteProjectAdditionalRemark"
          ></div>
        </div>
        <div class="project_item" v-if="!voteInfo.IsSubmit">
          <div class="btnBox">
            <el-button
              :class="
                project.SelectState === parseInt(btnItem.key)
                  ? 'vote_btn_active'
                  : 'vote_btn'
              "
              plain
              v-for="(btnItem, index) in voteInfo.VoteButtonConfig"
              :key="index"
              @click="changeSelectState(project, btnItem)"
            >
              {{ btnItem.value }}
            </el-button>
          </div>
        </div>
        <div class="project_item" v-if="voteInfo.IsSubmit">
          <div class="content">
            已选择：
            <span :style="{ color: project.SelectStateTextColor }">{{
              project.SelectStateText
            }}</span>
          </div>
          <div class="text_right">原序号：{{ project.Sort }}</div>
        </div>
      </div>
    </div>
    <div class="mobile_vote_operate_box">
      <el-button
        type="primary"
        size="medium"
        class="operate_btn"
        v-if="voteInfo.VoteSubmitConfig.isShow && !voteInfo.IsSubmit"
        :disabled="
          voteInfo.Status !== 1 ||
          voteInfo.IsSubmit !== 0 ||
          !voteInfo.IsVoteAllow
        "
        @click="submitVote()"
      >
        {{ voteInfo.VoteSubmitConfig.textValue }}
      </el-button>
      <el-button
        type="primary"
        size="medium"
        class="operate_btn"
        v-if="voteInfo.VoteResetConfig.isShow && !voteInfo.IsSubmit"
        @click="reset()"
      >
        {{ voteInfo.VoteResetConfig.textValue }}
      </el-button>
      <el-button
        type="primary"
        size="medium"
        class="operate_btn"
        v-if="voteInfo.AllSelectConfig.isShow && !voteInfo.IsSubmit"
        @click="allSelect()"
      >
        {{ voteInfo.AllSelectConfig.allValue }}
      </el-button>
      <el-button
        type="primary"
        size="medium"
        class="operate_btn"
        v-if="voteInfo.IsSubmit"
        @click="goBack()"
      >
        返回列表
      </el-button>
      <el-button
        type="primary"
        size="medium"
        class="operate_btn"
        v-if="
          voteInfo.CanSeeResult && voteInfo.IsSubmit && voteInfo.Status === 3
        "
        @click="openResult()"
      >
        查看结果
      </el-button>
    </div>
  </div>
</template>

<script>
import voteApi from '../../api/mobileVote/vote'
import 'signalr'
export default {
  data () {
    return {
      voteMainStyle: {
        marginTop: '100px'
      },
      voteInfo: {
        AllSelectConfig: [],
        VoteSubmitConfig: [],
        VoteResetConfig: []
      },
      voteStates: [],
      isInit: true,
      screenFlow: {},
      conn: {}
    }
  },
  methods: {
    goBack: function () {
      if (this.voteInfo.IsSubmit) {
        this.$router.push({ name: 'voteList', params: { mid: this.$route.params.mid } })
      } else {
        this.saveVote('goBack')
      }
    },
    refresh: function () {
      if (this.voteInfo.IsSubmit) {
        this.getShortlistedVoteInfo()
      } else {
        this.saveVote('refresh')
      }
    },
    getShortlistedVoteInfo: function () {
      const _this = this
      const openLoading = _this.openLoading()
      voteApi.getShortlistedVoteInfo({
        voteId: _this.$route.params.vid
      }).then(data => {
        _this.voteInfo = data
        _this.voteStates = []
        _this.voteInfo.VoteButtonConfig.forEach(item => {
          const state = JSON.parse(JSON.stringify(item))
          state.selectNum = 0
          state.selectCheckNum = 0
          _this.voteStates.push(state)
        })
        _this.voteInfo.VoteProjectList.forEach(projectItem => {
          _this.voteStates.forEach(stateItem => {
            if (projectItem.SelectState === parseInt(stateItem.key)) {
              stateItem.selectNum += 1
              projectItem.SelectStateText = stateItem.value
              projectItem.SelectStateTextColor = stateItem.color
            }
          })
        })
        _this.$nextTick(() => {
          _this.voteMainStyle.marginTop = (_this.$refs.mobileVoteBar.offsetHeight + 45) + 'px'
        })
        if (_this.voteInfo.IsScreen) {
          if (_this.isInit) {
            this.connectionHub()
          } else {
            openLoading.close()
          }
        } else {
          openLoading.close()
        }
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    changeSelectState: function (project, btnItem) {
      const oldSelectState = project.SelectState
      if (project.SelectState !== parseInt(btnItem.key)) {
        project.SelectState = parseInt(btnItem.key)
      } else {
        project.SelectState = null
      }
      this.changeSelectStateNum(project, oldSelectState)
    },
    changeSelectStateNum: function (project, oldSelectState) {
      const _this = this
      _this.voteStates.forEach(stateItem => {
        stateItem.selectCheckNum = 0
      })
      _this.voteInfo.VoteProjectList.forEach(projectItem => {
        _this.voteStates.forEach(stateItem => {
          if (projectItem.SelectState === parseInt(stateItem.key)) {
            stateItem.selectCheckNum += 1
          }
        })
      })
      _this.voteStates.forEach(stateItem => {
        if (parseInt(stateItem.key) === project.SelectState) {
          if (stateItem.isCheckMaxMin) {
            if (stateItem.selectCheckNum > stateItem.maxNum) {
              project.SelectState = parseInt(oldSelectState)
              _this.$message({
                type: 'error',
                message: '您最多可选' + stateItem.value + '数为' + stateItem.maxNum
              })
            } else {
              stateItem.selectNum = stateItem.selectCheckNum
            }
          } else {
            stateItem.selectNum = stateItem.selectCheckNum
          }
        } else {
          stateItem.selectNum = stateItem.selectCheckNum
        }
      })
    },
    reset: function () {
      const _this = this
      const openLoading = _this.openLoading()
      _this.voteStates.forEach(stateItem => {
        stateItem.selectNum = 0
      })
      for (let i = 0; i < _this.voteInfo.VoteProjectList.length; i++) {
        _this.voteInfo.VoteProjectList[i].SelectState = _this.voteInfo.ResetDefault
        _this.$set(_this.voteInfo.VoteProjectList, i, _this.voteInfo.VoteProjectList[i])
        _this.voteStates.forEach(stateItem => {
          if (_this.voteInfo.VoteProjectList[i].SelectState === parseInt(stateItem.key)) {
            stateItem.selectNum += 1
          }
        })
      }
      openLoading.close()
    },
    allSelect: function () {
      const _this = this
      const openLoading = _this.openLoading()
      let maxAllSelectNum = -1
      _this.voteInfo.VoteButtonConfig.forEach(item => {
        if ((_this.voteInfo.AllSelectConfig.key + '') === item.key) {
          if (item.isCheckMaxMin) {
            maxAllSelectNum = item.maxNum
          }
        }
      })
      _this.voteStates.forEach(stateItem => {
        stateItem.selectNum = 0
      })
      for (let i = 0; i < _this.voteInfo.VoteProjectList.length; i++) {
        if (i < maxAllSelectNum) {
          _this.voteInfo.VoteProjectList[i].SelectState = parseInt(_this.voteInfo.AllSelectConfig.key)
          _this.$set(_this.voteInfo.VoteProjectList, i, _this.voteInfo.VoteProjectList[i])
        } else {
          _this.voteInfo.VoteProjectList[i].SelectState = null
          _this.$set(_this.voteInfo.VoteProjectList, i, _this.voteInfo.VoteProjectList[i])
        }
        _this.voteStates.forEach(stateItem => {
          if (_this.voteInfo.VoteProjectList[i].SelectState === parseInt(stateItem.key)) {
            stateItem.selectNum += 1
          }
        })
      }
      openLoading.close()
    },
    submitVote: function () {
      const _this = this
      _this.$confirm('确定提交吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'vote_message_box'
      }).then(() => {
        _this.saveVote('submit')
      }).catch(() => {

      })
    },
    saveVote: function (action) {
      const _this = this
      let noPassNum = 0
      // 检查
      _this.voteStates.forEach(stateItem => {
        if (stateItem.isCheckMaxMin) {
          if (stateItem.selectNum > stateItem.maxNum) {
            _this.$message({
              type: 'error',
              message: '您最多可选' + stateItem.value + '数为' + stateItem.maxNum
            })
            noPassNum += 1
          }
          if (stateItem.selectNum < stateItem.minNum) {
            _this.$message({
              type: 'error',
              message: '选择' + stateItem.value + '数最少为' + stateItem.minNum
            })
            noPassNum += 1
          }
        }
      })
      if (noPassNum > 0) {
        return
      }
      // 提交参数
      const voteProjectList = []
      _this.voteInfo.VoteProjectList.forEach(item => {
        const voteProject = {}
        voteProject.VoteProjectId = item.VoteProjectID
        voteProject.SelectState = item.SelectState
        voteProjectList.push(voteProject)
      })
      const param = {
        VoteId: _this.voteInfo.VoteID,
        VoteNumber: _this.voteInfo.UserVoteNumber,
        Action: 'all_save',
        VoteProjectList: voteProjectList
      }
      if (action === 'submit') {
        param.Action = 'submit'
      }
      // 提交
      const openLoading = _this.openLoading()
      voteApi.shortlistedVote(param).then(data => {
        if (action === 'save') {
          _this.getShortlistedVoteInfo()
          _this.$message({
            type: 'success',
            message: '已保存'
          })
        }
        if (action === 'submit') {
          _this.getShortlistedVoteInfo()
          _this.$message({
            type: 'success',
            message: '投票已提交'
          })
        }
        if (action === 'goBack') {
          this.$router.push({ name: 'voteList', params: { mid: this.$route.params.mid } })
        }
        if (action === 'refresh') {
          _this.getScoreVoteInfo()
        }
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    openResult: function () {
      this.$router.push({ name: 'result', params: { mid: this.$route.params.mid, vid: this.$route.params.vid, voteType: 0 } })
    },
    connectionHub: function () {
      const _this = this
      const voteId = _this.$route.params.vid
      const state = JSON.parse(window.localStorage.getItem('state'))
      const token = state.token
      const baseUrl = _this.$config.baseSite

      _this.conn = window.jQuery.hubConnection(baseUrl, { qs: 'access_token=' + token })
      const chatHubProxy = _this.conn.createHubProxy('screenFlowHub')

      chatHubProxy.on('addRoom', function () {

      })

      _this.conn.start().done((data) => {
        chatHubProxy.invoke('addRoom', voteId)
          .done((data) => {
            _this.openLoading().close()
            _this.isInit = false
            _this.$message({ showClose: true, type: 'success', message: '投票准备就绪' })
          })
          .fail((msg) => {
            _this.openLoading().close()
            _this.isInit = false
            _this.$message({ showClose: true, type: 'error', message: '投票准备失败' })
          })
      }).fail((msg) => {
        _this.openLoading().close()
        _this.isInit = false
        _this.$message({ showClose: true, type: 'error', message: '投票准备失败' })
      })

      _this.conn.error((error) => {
        console.log(error)
      })
      // 重新连接
      _this.conn.reconnected(() => {
        // console.log('重新连接')
      })
      // 当连接已断开连接
      _this.conn.disconnected(() => {
        // console.log('当连接已断开连接')
      })
      // 接收消息
      _this.conn.received((data) => {
        if (data.H && data.M && data.A) {
          if (data.H === 'ScreenFlowHub' && data.M === 'sendScreenFlow' && data.A) {
            _this.screenFlow = JSON.parse(data.A[0])
            // alert(_this.screenFlow.IsAdmin)
            _this.screenFlowStepChange()
          }
        }
      })

      // 当客户端检测到慢速或频繁删除连接时引发
      _this.conn.connectionSlow(() => {
        // console.log('当客户端检测到慢速或频繁删除连接时引发')
      })
    },
    screenFlowStepChange: function () {
      // MeetingId    GroupId    VoteId     ProjectId    StepId    IsBegin
      switch (this.screenFlow.StepId) {
        case '001':
          if (this.screenFlow.VoteType === 0) {
            if (this.$route.params.vid === this.screenFlow.VoteId) {

            } else {
              this.$router.push({ name: 'shortlist', params: { mid: this.$route.params.mid, vid: this.screenFlow.VoteId } })
            }
          }
          if (this.screenFlow.VoteType === 3) {
            this.$router.push({ name: 'judgeVote', params: { mid: this.$route.params.mid, vid: this.screenFlow.VoteId } })
          }
          break
        case '002':

          break
        case '003':
          this.$router.push({ name: 'result', params: { mid: this.$route.params.mid, vid: this.$route.params.vid, voteType: 0 } })
          break
        case '004':

          break
      }
    }
  },
  created () {
    this.getShortlistedVoteInfo()
  },
  beforeDestroy () {
    this.conn.stop()
  },
  watch: {
    $route () {
      this.conn.stop()
      this.isInit = true
      this.getShortlistedVoteInfo()
    }
  }
}
</script>

<style lang="less">
@import '../../assets/css/mobileVote/vote.css';
</style>
